import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import './CashType.scss';
import BackArrow from 'src/atoms/backArrow/backArrow';
import rightArrow from 'src/assets/images/right_caret.svg';
import WarnRed from 'src/assets/images/warn-circle-red.svg';
import GenericModal from 'src/GenericModal';
import { makeAPICall } from 'src/services/apiService';
import graySearchIcon from 'src/assets/testRide/gray-search.svg';



const CashType = () => {

  const history = useHistory();
  const [splitPayments, setSplitPayments] = useState([])
  const [failedPopup, setFailedPopup] = useState(false);
  const [allPaymentTransactions, setAllPaymentTransactions] = useState([]);
  const userInfo = JSON.parse(sessionStorage.getItem("user_details"))
  console.log("userInfo in CashType", userInfo)

  useEffect(() => {
    getOfflineSplits('', '').then((res) => {
      console.log("calling getOfflineSplits success : ", res);
    }).catch((err) => {
      console.log("calling getOfflineSplits error : ", err);
    })

  }, [])


  const sttOrderCheck = (status, order_id, user_id) => {
    if (status == "FAILED") {
      setFailedPopup(true);
    }
    else {
      history.push('/cash-type-payments',{order_id : order_id, user_id : user_id});
    }
  }
  const getOfflineSplits = async (id, user_id) => {
    return new Promise(async (resolve, reject) => {
      console.log("Inside CashType in getOfflineSplits id , user_id : ", id, user_id)
      let offlineSplitsPayload = {
        method: 'get',
        url: 'api/offlinePayment/getOfflineSplits',
        params: {
          orderId: id,
          customer_uuid: 'hgjhgjhghgh'
        }
      }
      console.log("Inside CashType offlineSplitsPayload : ", offlineSplitsPayload)
      await makeAPICall(offlineSplitsPayload)
        .then((resp) => {
          console.log("Inside CashType resp in getOfflineSplits : ", resp)
          let allPaymentTransactions = resp.data?.all_payment_transactions;
          let pendingTransactions = allPaymentTransactions.filter((ele)=>{
            return ele.status == "INITIATED";
          })
          let allFailedTransactions = allPaymentTransactions.filter((ele)=>{
            return ele.status == "FAILED";
          })
          console.log("Inside CashType pendingTransactions : ", pendingTransactions);
          console.log("Inside CashType allFailedTransactions : ", allFailedTransactions);
          allPaymentTransactions = [...pendingTransactions, ...allFailedTransactions];
          console.log("Inside CashType allPaymentTransactions XXXX : ", allPaymentTransactions);
          setAllPaymentTransactions(allPaymentTransactions);
          console.log("Inside CashType allPaymentTransactions : ", allPaymentTransactions);
          resolve("success");
        })
        .catch((err) => {
          reject("error");
          console.log("error in getting offlineSplits Payload", err);
        })
    });
  }
  return (
    <div className='cashType-container'>
      <div className='cashType-header-div'>
        <div onClick={() => {
          // history.back();
          history.push("/apply-coupon-search?offinepayment=true");
        }}>
          <BackArrow />
        </div>
        {/* </div> */}
        <div className='cashType-header'>Pending/Failed Cash Transaction</div>
      </div>


      {/* cashTypeList.length == 0 ?   */}
      {allPaymentTransactions.length == 0 ? (
        <div className="no-orders">
          <div
            style={{
              width: 180,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <img
              src={graySearchIcon}
              alt="searchIcon"
              style={{ height: 60, width: 60 }}
            />
            <p>No Transaction</p>
          </div>
        </div>
      ) : (

        <div className='cashTypeList-container'>
          {allPaymentTransactions.map((order) => (
            <div className="orderlist-container">
              <div>
                <div className="order-number">{order?.order_id}</div>
                <div className={`user-name ${order?.status === 'INITIATED' ? 'pending-class' : order?.status === 'FAILED' ? 'failed-class' : ''}`}>
                  {(order?.status == 'INITIATED' ? "Pending" : order?.status == 'FAILED' ? 'Failed' : order?.status)}
                </div>
              </div>
              <img
                src={rightArrow}
                alt="rightArrow"
                style={{ height: 30, width: 30 }}
                onClick={() => {
                  sttOrderCheck(order?.status, order?.order_id, order?.user_id);
                }}
              />

            </div>
          ))}

        </div>
      )}


      {failedPopup && (
        <GenericModal onClose={() => setFailedPopup(false)} showClose={false}>
          <div className={`tr-validation-container ${"trCont"}`}>
            <div className="heading-container">
              <p className="error-heading">This transaction is rejected</p>
              <img src={WarnRed} alt="warning" className="warn-icon" />
            </div>
            <div className="error-subheading">
              <div>Finance team has rejected this transaction. Please reach out to the team for clarification.</div>
            </div>
            <div className="two-btns">
              <button
                className="confirm"
                onClick={() => {
                  setFailedPopup(false)
                }}
              >
                Got it
              </button>
            </div>
          </div>
        </GenericModal>
      )}
    </div>




  );
}

export default CashType;
